import { createSelector } from 'reselect';

import { LISTING_STATUS } from '../products/constants/listingStatus';
import readDraftDomains from '../products/helpers/readDraftDomains';
import resolveDraftScopeChrome from '../products/helpers/resolveDraftScopeChrome';
import { selectEffectiveChannelState } from './productSelectors';

const selectProducts = (state) => state.products;
const selectProductIdArg = (_, productId) => productId;
const selectVariantIdArg = (_, __, variantId) => variantId || null;

export const selectDraftScopeChrome = createSelector(
  selectProducts,
  selectEffectiveChannelState,
  selectProductIdArg,
  selectVariantIdArg,
  (products, channelState, productId, variantId) => {
    const isDraftLayer = !channelState?.isMasterView
      && channelState?.activeTab === LISTING_STATUS.DRAFT;

    return resolveDraftScopeChrome({
      isDraftLayer,
      draftDomains: readDraftDomains(
        products,
        productId,
        variantId,
        channelState?.contextChannelId,
      ),
    });
  },
);
